import { UiDrawer, UiTextBox, UiTextArea, UiButton, UiDatePicker, UiWarningRating, UiProfileModel } from "../../../../components";
import { userIcon } from "../../../../assets/images";
import { formatPhoneNumber } from "../../../../utils/appUtils";
import "./style.scss";
import dayjs from "dayjs";

const GenerateCouponDrawer = ({ open, customerData, formData, onClose, onInputChange, onSubmit, isEditMode }) => {
    const handleCancel = () => {
        onClose();
    };
    const prefixLength = formData?.prefix?.length ?? 0;
    const isPrefixInvalid = !isEditMode && prefixLength > 0 && prefixLength !== 4;
    const couponPercentage = formData?.couponPercentage ? Number(formData?.couponPercentage) : null;
    const isPercentageInvalid = Boolean(formData?.couponPercentage && (couponPercentage > 5 || couponPercentage <= 0 || isNaN(couponPercentage)));
    const descriptionLength = formData?.description?.length ?? 0;
    const isDescriptionInvalid = descriptionLength > 150;
    const isFormValid = (isEditMode || (formData?.prefix && formData?.prefix?.length === 4)) && formData?.couponPercentage && !isPercentageInvalid && formData?.startDate && formData?.endDate && formData?.dayCount && formData?.description && !isDescriptionInvalid;
    return (
        <UiDrawer
            title="Coupon Generate"
            open={open}
            onClose={handleCancel}
            size="default"
            width={500}
        >
            <div className="generate-coupon-drawer-content">
                <div className="content-wrapper">
                    <div className="customer-profile-card">
                        <div className="flexible" style={{ borderBottom: "1px solid #000", paddingBottom: "10px", marginBottom: "10px", justifyContent: "space-between" }}>
                            <div className="flexible">
                                <div className="profile-avatar" style={{ marginRight: "10px" }}>
                                    {
                                        !customerData?.profileImage || customerData?.profileImage?.includes("null") || customerData?.profileImage?.includes("undefined") ?
                                            <img src={userIcon} style={{ width: "50px", height: "50px", borderRadius: "50%", objectFit: "cover" }} alt="" /> :
                                            <UiProfileModel imageUrl={customerData?.profileImage} />
                                    }
                                </div>
                                <div>
                                    <h3 className="lawerInfo-detail">{customerData?.customerName || "Nil"}</h3>
                                    <div style={{ padding: "5px 0" }}>
                                        <UiWarningRating count={customerData?.warningCount} />
                                    </div>
                                </div>
                            </div>
                            <div>
                                <small className="information-header">Customer ID</small>
                                <h3 className="lawerInfo-detail">{customerData?.customerNo || "Nil"}</h3>
                            </div>
                        </div>
                        <div className="flexible" style={{ justifyContent: "space-between" }}>
                            <div>
                                <small className="information-header">Mobile Number</small>
                                <h3 className="lawerInfo-detail">{customerData?.mobileNumber ? formatPhoneNumber(customerData?.mobileNumber) : "Nil"}</h3>
                            </div>
                            <div>
                                <small className="information-header">E-mail Address</small>
                                <h3 className="lawerInfo-detail">{customerData?.email || "Nil"}</h3>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="textbox-wrapper">
                            <UiTextBox
                                label="Prefix"
                                required={true}
                                placeholder="Eg: DWLI"
                                value={formData?.prefix}
                                status={isPrefixInvalid ? "error" : ""}
                                onChange={(event) => {
                                    const val = event.target.value.toUpperCase().slice(0, 4);
                                    onInputChange("prefix", val);
                                }}
                                disabled={isEditMode}
                            />
                            {isPrefixInvalid ? <small className="prefix-validation-message">Prefix must contain 4 characters</small> : null}
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="textbox-wrapper">
                            <UiTextBox
                                label="Coupon Percentage %"
                                required={true}
                                placeholder="Eg: 5%"
                                value={formData?.couponPercentage}
                                status={isPercentageInvalid ? "error" : ""}
                                onChange={(event) => {
                                    const digits = event?.target?.value?.replace(/[^0-9]/g, "")?.slice(0, 2);
                                    onInputChange("couponPercentage", digits);
                                }}
                            />
                            {isPercentageInvalid ? (
                                <small className="prefix-validation-message">
                                    {Number(formData?.couponPercentage) > 5 ? "Percentage cannot exceed 5%" : "Percentage must be greater than 0%"}
                                </small>
                            ) : null}
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="form-label">
                            Start Date <span className="required">*</span>
                        </label>
                        <UiDatePicker
                            placeholder="Select date"
                            value={formData?.startDate ? dayjs(formData?.startDate) : null}
                            onChange={(date) => onInputChange("startDate", date)}
                            disabledDate={(currentDate) => currentDate && currentDate < dayjs().startOf("day")}
                            style={{ width: "100%" }}
                        />
                    </div>
                    <div className="form-group">
                        <label className="form-label">
                            End Date <span className="required">*</span>
                        </label>
                        <UiDatePicker
                            placeholder="Select date"
                            value={formData?.endDate ? dayjs(formData?.endDate) : null}
                            onChange={(date) => onInputChange("endDate", date)}
                            disabledDate={(currentDate) =>
                                currentDate &&
                                (formData?.startDate
                                    ? currentDate < dayjs(formData.startDate).startOf("day")
                                    : currentDate < dayjs().startOf("day"))
                            }
                            style={{ width: "100%" }}
                        />
                    </div>
                    <div className="form-group">
                        <div className="textbox-wrapper">
                            <UiTextBox
                                label="Day Count"
                                required={true}
                                placeholder="0"
                                value={formData?.dayCount}
                                disabled
                                type="number"
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="textbox-wrapper">
                            <UiTextArea
                                label="Description"
                                required={true}
                                placeholder="Enter description"
                                value={formData?.description}
                                status={isDescriptionInvalid ? "error" : ""}
                                onChange={(event) => {
                                    const val = event?.target?.value?.slice(0, 150);
                                    onInputChange("description", val);
                                }}
                                maxLength={150}
                                showCount
                            />
                            {isDescriptionInvalid ? (
                                <small className="prefix-validation-message">
                                    Description cannot exceed 150 characters
                                </small>
                            ) : null}
                        </div>
                    </div>
                </div>
                <div className="drawer-footer">
                    <UiButton
                        className="cancel-btn"
                        onClick={handleCancel}
                    >
                        Cancel
                    </UiButton>
                    <UiButton
                        className="send-btn"
                        onClick={onSubmit}
                        disabled={!isFormValid}
                    >
                        Send
                    </UiButton>
                </div>
            </div>
        </UiDrawer>
    );
};

export default GenerateCouponDrawer;
